const UseHrefBuilder = () => {
	return (item: MainMenuItemInterface) =>
	({
		external: item.url,
		page: "/" === item.path ? item.path : `/${item.type}/${item.path}`,
		embed: `/${item.type}/${item.path}`,
		powerbi: `/${item.type}/${item.path}`,
		category: null,
	}[item.type]);
};

export default UseHrefBuilder;
